import { render, staticRenderFns } from "./AnnotationAutoCompleteUserSearch.vue?vue&type=template&id=4f57cac0&scoped=true"
import script from "./AnnotationAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
export * from "./AnnotationAutoCompleteUserSearch.vue?vue&type=script&lang=ts"
import style0 from "./AnnotationAutoCompleteUserSearch.vue?vue&type=style&index=0&id=4f57cac0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f57cac0",
  null
  
)

export default component.exports